// Auto-discovers every changelog entry in this folder. To publish a release, just
// add a `<staging-date>.json` file here — webpack's require.context bundles all of
// them at build time (`yarn start` / `yarn build`). No manifest, no build script, no CI.
//
// Each file is one entry conforming to ../changelog.schema.json.

const loadEntries = () => {
    // require.context is a webpack-only feature (statically transformed at build
    // time). Wrap in try/catch so it degrades to [] under Jest, where it is absent.
    try {
        const context = require.context('./', false, /\.json$/);

        return context.keys().map((key) => context(key));
    } catch (error) {
        return [];
    }
};

const entries = loadEntries();

export default entries;
